import { useQuery } from '@tanstack/react-query';
import { dailyLogService } from '../../services/daily-log.service';
import { queryKeys } from '../../lib/query-keys';

export function useDailyLogs(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.dailyLogs.all(orgId ?? ''),
    queryFn: () => dailyLogService.getDailyLogs({ limit: 200 }),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => {
      const raw = res?.data ?? res;
      return Array.isArray(raw) ? raw : [];
    },
  });
}
